import Text from '@/styles/Themes/Text';
import styled from 'styled-components';
import Palette from '@/styles/Themes/Palette';
import { cssVars } from '@/styles/Themes/cssVars';
import { borders, radius } from '@/styles/Themes/Metrics';
import ErrorMessage from '@/shared/images/icons/ErrorMessage';
import Screen from '@/styles/Themes/Screen';

export const ErrorMessageWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin: 0 auto 10px;
    border: ${borders.small} ${cssVars.bg_gray4_dark2};
    border-radius: ${radius.small};
    background: ${cssVars.bg_errLight_errDark};
    padding: 0 10px;
`;

export const ErrorMessageTitle = styled.p`
    color: ${Palette.state.error};
    ${Text.Mobile.small.semibold};

    ${Screen.desktop} {
        ${Text.Desktop.normal.medium};
    }
`;

export const ErrorMessageText = styled.p`
    color: ${cssVars.fg_error_text};
    ${Text.Mobile.small.semibold};

    ${Screen.desktop} {
        ${Text.Desktop.small.medium};
    }
`;

export const LeftPart = styled.div`
    padding: 14px 0 0 10px;

    ${Screen.desktop} {
        padding: 19px 0 0 10px;
    }
`;

export const RightPart = styled.div`
    padding: 7px 0 7px 8px;
    > svg circle {
        width: 11px;
        height: 11px;
    }
`;

export const ErrorIcon = styled(ErrorMessage)``;
